import builder from '../builder';
import AlertCircle from '../../streamline-icons/light/alert-circle.svg';

export default builder('IconAlertCircleLight', AlertCircle);
